export enum ErrorResponseCode {
  INCORRECT_PASSWORD = 'INCORRECT_PASSWORD',
  PASSWORD_TOO_WEAK = 'PASSWORD_TOO_WEAK',
  INVALID_TOKEN = 'INVALID_TOKEN',
  EXPIRED_TOKEN = 'EXPIRED_TOKEN',
  MISSING_PROVINCE_PERMIT = 'MISSING_PROVINCE_PERMIT',
  INVALID_HUMANIA_CODE = 'INVALID_HUMANIA_CODE',
  NOT_FOUND = 'NOT_FOUND',
  INVALID_INPUT = 'INVALID_INPUT',
  INVALID_SESSION = 'INVALID_SESSION',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER',
  INVALID_POSTAL_CODE = 'INVALID_POSTAL_CODE',
  INVALID_USER_INFO = 'INVALID_USER_INFO',
  INVALID_HEALTH_ANSWERS = 'INVALID_HEALTH_ANSWERS',
  INVALID_PROTECTION = 'INVALID_PROTECTION',
  INVALID_BENEFICIARY = 'INVALID_BENEFICIARY',
  INVALID_TRUSTEE = 'INVALID_TRUSTEE',
  INVALID_PAYMENT_INFO = 'INVALID_PAYMENT_INFO',
  INVALID_PROPOSAL_AGENT = 'INVALID_PROPOSAL_AGENT',
  INVALID_CONFIRMATION_STEPS = 'INVALID_CONFIRMATION_STEPS',
  INVALID_EXTRA = 'INVALID_EXTRA',
  INVALID_POLICY_REPLACEMENT = 'INVALID_POLICY_REPLACEMENT',
  INVALID_FNA = 'INVALID_FNA',
  INVALID_CURRENT_PROTECTION = 'INVALID_CURRENT_PROTECTION',
  INVALID_COVERAGE = 'INVALID_COVERAGE',
  INVALID_CATEGORY = 'INVALID_CATEGORY',
  INVALID_JOB_CATEGORY_ID = 'INVALID_JOB_CATEGORY_ID',
  MISSING_POLICY_REPLACEMENT = 'MISSING_POLICY_REPLACEMENT',
  TOO_MANY_ATTEMPTS = 'TOO_MANY_ATTEMPTS',
  INCORRECT_ID_DOCUMENT = 'INCORRECT_ID_DOCUMENT',
  DECISION_ALREADY_MADE = 'DECISION_ALREADY_MADE',
  FORBIDDEN = 'FORBIDDEN',
  VERSION_MISMATCH = 'VERSION_MISMATCH',
  DISABILITY_RIDER_NOT_ALLOWED = 'DISABILITY_RIDER_NOT_ALLOWED',
  CANCER_RIDER_NOT_ALLOWED = 'CANCER_RIDER_NOT_ALLOWED',
  COVERAGE_EXCEEDS_MAXIMUM = 'COVERAGE_EXCEEDS_MAXIMUM',
}

export interface ErrorResponse {
  code: ErrorResponseCode;
  message: string;
}
